import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Grid } from '@mui/material';
import { signOut, onAuthStateChanged } from 'firebase/auth';

import { Header } from './Header';
import { Sidemenu } from './Sidemenu';
import { AppRoutes } from './AppRoutes';
import { ProgressBackdrop } from '../_common/ProgressBackdrop';
import { AlertSnackbar } from '../_common/AlertSnackbar';

import { signIn, openSnackbar } from 'main/store/common/reducer';
import { auth } from 'main/utils/firebase';
import Axios from 'axios';

export const App = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        onAuthStateChanged(auth, async (user) => {
            if (user) {
                try {
                    const token = await auth.currentUser!.getIdToken(true);
                    dispatch(signIn({
                        id: user.uid,
                        token: token,
                        name: user.displayName ? user.displayName : '',
                        email: user.email ? user.email : ''
                    }));
                } catch (error) {
                    await signOut(auth);
                    let message: string;
                    if (Axios.isAxiosError(error) && error.response?.status === 403) {
                        message = '利用登録されていないので、メンバーページへはアクセスできません'
                    } else {
                        message = '予期せぬエラーが発生しました';
                    }
                    dispatch(openSnackbar({ severity: 'error', message }));
                    navigate('/');
                }
            }
        });
    }, [dispatch, navigate]);

    return (
        <Grid container direction="column" height={window.innerHeight}>
            <Header />
            <Sidemenu />
            <Grid item xs sx={{ overflow: 'auto' }}>
                <AppRoutes />
            </Grid>
            <ProgressBackdrop />
            <AlertSnackbar />
        </Grid>
    )
}
